import styled from 'styled-components';

const StyledInvoiceDetailsPanel = styled.div`

`;

export {
  StyledInvoiceDetailsPanel
};
